function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  stroke: "#B52907",
  fill: "none",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("path", {
  d: "M13.9 15.315a5.608 5.608 0 0 0 4.1 2.249 5.25 5.25 0 0 0 0-10.5c-3.75 0-6 5.25-6 5.25s-2.25 5.25-6 5.25a5.25 5.25 0 0 1 0-10.5 6.615 6.615 0 0 1 4.5 2.383"
}), React.createElement("path", {
  d: "M9.884 5.748l.616 3.699-3.699.617"
}));

var SvgLoop = function SvgLoop(props) {
  return React.createElement("svg", _extends({
    height: 24,
    width: 24
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbG5zOnN2Z2pzPSJodHRwOi8vc3ZnanMuY29tL3N2Z2pzIiB2aWV3Qm94PSIwIDAgMjQgMjQiIGhlaWdodD0iMjQiIHdpZHRoPSIyNCI+PHRpdGxlPmJ1dHRvbiBsb29wIGFycm93IChGcm9tIFN0cmVhbWxpbmUgQXBwIDogaHR0cHM6Ly9hcHAuc3RyZWFtbGluZWljb25zLmNvbSk8L3RpdGxlPjxnIHRyYW5zZm9ybT0ibWF0cml4KDEsMCwwLDEsMCwwKSI+PHBhdGggZD0iTSAxMy45LDE1LjMxNWMwLjk3NCwxLjMxMSwyLjQ3MSwyLjEzMiw0LjEsMi4yNDljMi44OTksMCw1LjI1LTIuMzUxLDUuMjUtNS4yNXMtMi4zNTEtNS4yNS01LjI1LTUuMjUgYy0zLjc1LDAtNiw1LjI1LTYsNS4yNXMtMi4yNSw1LjI1LTYsNS4yNWMtMi44OTksMC01LjI1LTIuMzUxLTUuMjUtNS4yNVMzLjEwMSw3LjA2NCw2LDcuMDY0YzEuNzU4LDAuMTYyLDMuMzc4LDEuMDIsNC41LDIuMzgzICIgc3Ryb2tlPSIjQjUyOTA3IiBmaWxsPSJub25lIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj48L3BhdGg+PHBhdGggZD0iTSA5Ljg4NCw1Ljc0OEwxMC41LDkuNDQ3bC0zLjY5OSwwLjYxNyIgc3Ryb2tlPSIjQjUyOTA3IiBmaWxsPSJub25lIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj48L3BhdGg+PC9nPjwvc3ZnPg==";
export { SvgLoop as ReactComponent };